module.exports = __webpack_public_path__ + "img/elite_natural_ba_list.fca5df13.jpg";